import { JobStartedModel } from "./JobStartedModel";

export class JobStartedService {
    private static DbName: string = 'isite-mob-db';
    private static DbVersion: number = 3;
    private static JobStartedQueue: string = 'jobs-started-queue';
    private static JobStartedQueueKey: string = 'Id';
    private IndxDb: IDBFactory;

    constructor() {
        this.IndxDb = self.indexedDB;

        if (this.IndxDb) {
            console.log('IndexedDB is supported');
            this.OpenInitDb();
        }
        else {
            console.log('[Failed] IndexedDB NOT SUPPORTED');
        }
    }

    public SetJobStarted(jobId: number, onsuccess?: any): void {
        const jobStarted: JobStartedModel = { Id: jobId, StartedOn: new Date().toJSON() };

        if (navigator.onLine) {
            this.PostSetJobStarted(jobStarted, (isPosted: boolean) =>
            {
                if (onsuccess != null) onsuccess(isPosted);
            });
        }
        else {
            this.AddJobStartedToQueue(jobStarted, () => {
                if (onsuccess != null) onsuccess(false);
            });            
        }
    }

    public GetJobsStartedQueue(onsuccess?: any, onerror?: any): void {
        const openDb = this.OpenDb();

        openDb.onsuccess = (event: any) => {
            const db = event.target.result;
            const t = db.transaction(JobStartedService.JobStartedQueue, 'readwrite');

            t.onsuccess = (event: any) => {
                console.log('[ProcessJobStartedQueue] COMPLETED');
            };
            t.onerror = (event: any) => {
                onerror(event);
            };

            const jobsStartedStore = t.objectStore(JobStartedService.JobStartedQueue);
            const dbReq = jobsStartedStore.getAll();

            dbReq.onsuccess = (event: any) => {
                if(onsuccess != null) onsuccess(event.target.result);
            }

            dbReq.onerror = (event: any) => {
                onerror(event);
            }
        }
    }

    public ProcessJobStartedQueue(onsuccess: any, onerror?: any): void {
        this.GetJobsStartedQueue(
            (data: any) => {
                if (data !== null) {
                    data.forEach((job: JobStartedModel, index: number, array: JobStartedModel[]) =>
                        this.PostSetJobStarted(job, (posted: boolean) => {
                            if (index === array.length - 1 && onsuccess != null) {
                                onsuccess(posted);
                            }
                        }));
                }
            },
            (event: any) => {
                console.log('[ERROR] Getting queue !!!');
                if (onerror != null) onerror(event);
            }
        );
    }

    private PostSetJobStarted(jobData: JobStartedModel, onsuccess?: any, onerror?: any): void {
        $.post({
            url: (window as any)._iSitePathBase + 'Job/SetJobStarted',
            data: jobData
        }).then((processed: boolean) => {
            if (typeof processed === "boolean" && processed) {
                this.RemoveJobStartedFromQueue(jobData);
                if (onsuccess != null) onsuccess(true);
            }
            else {
                this.AddJobStartedToQueue(jobData);
                if (onsuccess != null) onsuccess(true);
            }
        }).catch((event: any) => {
            this.AddJobStartedToQueue(jobData);
            console.log('[Failed] Ajax Post');
            if (onsuccess != null) onsuccess(false);
        });
    }



    //// IndexDb Methods ////

    private OpenDb(): any {
        const request = this.IndxDb.open(JobStartedService.DbName, JobStartedService.DbVersion);

        request.onerror = (event: any) => {
            console.log('[Failed] OpenDb');
        }

        return request;
    }

    private OpenInitDb(): any {
        const openDb = this.OpenDb();

        openDb.onupgradeneeded = (event: any) => {
            const db = event.target.result;
            const store = db.createObjectStore(JobStartedService.JobStartedQueue, { keyPath: JobStartedService.JobStartedQueueKey });
        };

        return openDb;
    }

    public AddJobStartedToQueue(jobStarted: JobStartedModel, onsuccess?: any): void {
        const openDb = this.OpenDb();
        openDb.onsuccess = (event: any) => {
            const db = event.target.result;
            const t = db.transaction(JobStartedService.JobStartedQueue, 'readwrite');

            t.onsuccess = (event: any) => {
                console.log('[Transaction] Add to Queue complete');
            };

            const jobsStartedStore = t.objectStore(JobStartedService.JobStartedQueue);

            const dbReq = jobsStartedStore.add(jobStarted);

            dbReq.onsuccess = (event: any) => {
                if (event.target.result === jobStarted.Id) {
                    console.log('[Added] ' + jobStarted.Id + ' to Queue');
                    if (onsuccess != null) return onsuccess();
                }
                else
                    console.log('[Failed] ' + event.target.result + ' != ' + jobStarted.Id);
            }

            dbReq.onerror = (event: any) => {
                console.log('[Failed] ' + event.target.error.message);
            }
        };
    }

    private RemoveJobStartedFromQueue(jobStarted: JobStartedModel): void {
        const openDb = this.OpenDb();
        openDb.onsuccess = (event: any) => {
            const db = event.target.result;
            const t = db.transaction(JobStartedService.JobStartedQueue, 'readwrite');

            t.onsuccess = (event: any) => {
                console.log('[Transaction]  Remove from Queue complete');
            };

            const jobsStartedStore = t.objectStore(JobStartedService.JobStartedQueue);

            const dbReq = jobsStartedStore.delete(jobStarted.Id);

            dbReq.onsuccess = (event: any) => {
                    console.log('[Removed] ' + jobStarted.Id + ' from Queue');
            }

            dbReq.onerror = (event: any) => {
                console.log('[Failed] ' + event.target.error.message);
            }
        };
    }
}
